import { useCallback, useState } from "react";
import {
  useWSInLayoutsUpdated,
  useWSOutLayoutsUpdated,
} from "../hooks/useWebSocket";

const useDashboardLayouts = (token) => {
  const [layouts, setLayouts] = useState({
    grid: undefined,
    pipeline: undefined,
  });

  const sendLayoutsUpdate = useWSOutLayoutsUpdated(token);
  useWSInLayoutsUpdated(setLayouts);

  const updateLayouts = useCallback(
    async (type, newLayouts) => {
      if (type == "all") {
        setLayouts(newLayouts);
        sendLayoutsUpdate(newLayouts);
        return;
      }

      if (JSON.stringify(newLayouts) !== JSON.stringify(layouts[type])) {
        setLayouts({ ...layouts, [type]: newLayouts });
        sendLayoutsUpdate({ ...layouts, [type]: newLayouts });
      }
    },
    [sendLayoutsUpdate]
  );

  return { layouts, updateLayouts };
};

export { useDashboardLayouts };
